module.exports = {
  init: async function(parent,settings={}){
    this._parent=parent;
    this._settings=settings;
    this._settings['stale_days']='14';
    this._cache=false;
  },
  refresh:async function()
  {
    this._cache=false;
    return this.get();
  },
  get:async function(query=false,force=false,expire=true)
  {
    if(force || query)
    {
      this._cache=false;
    }

    this._parent._log('debug','readlater.get','Getting',{query:query, force:force});
    if(!this._cache)
    {
      this._cache = {'type': 'profile', 'name': 'readlater', 'data':{}, 'status': 'published'};

      let current_data = await this._parent.get('data','?type=profile&name=readlater&status=published&_[limit]=1',false,true);

      this._parent._log('debug','readlater.get','No cache',current_data);

      let used_local = false;

      if(current_data)
      {
       this._parent.post('local',{id:'cache__readlater','status':'published','data':current_data});
      }
      else
      {
        if(await this._parent.is_offline())
        {
          let _current_data = await this._parent.get('local','id=cache__readlater');
          this._parent._log('debug','readlater.get','local?id=cache__readlater',_current_data);
          if(_current_data)
          {
            if('data' in _current_data)
            {
              current_data=_current_data.data;
              used_local=true;
            }
          }
        }
      }

      if(Array.isArray(current_data))
      {
        if(current_data.length == 1)
        {
          this._parent._log('debug','readlater.get','Processing return',current_data);
          if('data' in current_data[0])
          {
            this._cache.data = JSON.parse(JSON.stringify(current_data[0].data));
            for(let a_query in query)
            {
              for(let key in this._cache.data)
              {
                if((a_query in this._cache.data[key]) && (this._cache.data[key][a_query] == query[a_query]))
                {
                  // Ok
                }
                else
                {
                  delete this._cache.data[i];
                }
              }
            }

            if(expire)
            {
              // Check for expiration
              let current_date = new Date();
              current_date=new Date(current_date.getFullYear(),current_date.getMonth(),current_date.getDate()).getTime()/1000;
              let stale_post_ids = [];
              for(let key in this._cache.data)
              {
                if('lastupdate' in this._cache.data[key])
                {
                  let stale_date = parseInt(this._cache.data[key]['lastupdate'])+(parseInt(this._settings['stale_days']) * 24 * 60 * 60);
                  this._parent._log('debug','readlater.get','Checking for stale if ('+this._cache.data[key]['lastupdate']+' + '+(parseInt(this._settings['stale_days']) * 24 * 60 * 60)+') '+stale_date+'>'+current_date+'',);
                  if(stale_date<current_date)
                  {
                    stale_post_ids.push(key);
                  }
                  else
                  {
                    this._cache.data[key]['generated::expiration']=this._parent.timestamp_diff(current_date,stale_date);
                  }
                }
              }
              if(stale_post_ids.length>0)
              {
                await this.remove(stale_post_ids,false);
              }
            }
            this._parent._log('debug','readlater.get','From db',this._cache);
          }
          else
          {
            this._parent._log('debug','readlater.get','mmm data missing',current_data[0]);
          }
        }
      }
      else
      {
        this._parent._log('error','readlater.get','returned data isnt a array',current_data);
        throw {code:500,'message':'get:: returned data isnt a array','data':current_data,'used_local':used_local};
      }

    }
    else
    {
      this._parent._log('debug',''+this._id+'.get','Has Cache',this._cache);
    }


    return this._cache;
  },
  has:async function(post_id,callback=false)
  {
    let current_data = await this.get();
    let result = false;
    if(typeof current_data === 'object' && 'data' in current_data)
    {
      if(post_id in current_data.data)
      {
        if('name' in current_data && current_data.name=='readlater')
        {
          result=true;
        }
      }
    }
    if(typeof callback == 'function')
    {
      callback(result);
    }
    return result;
  },
  toggle:async function(post_id,title,images,excerpt,metadata=[],type=false,service=false,source=false,callback=false)
  {
    let result = false;
    let action = '';
    this._parent._log('debug','readlater.toggle','Toggling '+post_id);

    if(await this.has(post_id))
    {
      result = await this.remove(post_id);
      action = 'removed';
    }
    else
    {
      result = await this.add(post_id,title,images,excerpt,metadata,type,service,source);
      action = 'added'
    }


    this._parent._log('debug','readlater.toggle',action,post_id,result);

    if(result && typeof callback == 'function')
    {
      callback(action);
    }
    return result;
  },
  remove:async function(post_id,force=true)
  {
    let post_ids = [];
    if(!Array.isArray(post_id))
    {
      post_ids.push(post_id);
    }
    else
    {
      post_ids=post_id;
    }

    let current_data = await this.get(false,force,false);
    if(typeof current_data === 'object' && 'data' in current_data)
    {
      for(let i=0;i<post_ids.length;i++)
      {
        this._parent._log('debug','readlater.remove','Removing '+post_ids[i],current_data);
        if(post_ids[i] in current_data.data)
        {
          delete current_data.data[post_ids[i]];
        }
      }
      this._cache = current_data;
      if('name' in current_data && current_data.name=='readlater')
      {
          window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
            'event_type':'readlater',
            'data': {
              'action':'remove',
              'id':post_id
            }
          }}));
          return await this._parent.post('data',current_data);
      }
      else
      {
        return false;
      }
    }
    else
    {
      return false;
    }
  },
  touch:async function(post_id)
  {
    if(this._parent.has_localdb())
    {
      try
      {
        if(post_id && !(isNaN(post_id)))
        {
          let current_data = await this.get(false,true);
          if(typeof current_data === 'object' && 'data' in current_data)
          {
            this._parent._log('debug','readlater.touch','Touching '+post_id,current_data);

            let current_date = new Date();
            current_date=new Date(current_date.getFullYear(),current_date.getMonth(),current_date.getDate()).getTime()/1000;
            current_data.data[post_id]['lastupdate']=current_date;

            this._parent._log('debug','readlater.touch','Updating',current_data);

            if('name' in current_data && current_data.name=='readlater')
            {
              return await this._parent.post('data',current_data);
            }
            else
            {
              return false;
            }

          }
          else
          {
            throw "current_data is not an object or is missing data";
          }
        }
        else
        {
          throw "post_id is not a number";
        }

      }
      catch(ex)
      {
          this._parent._log('error','readlater.add',ex);
          return false;
      }
    }
    else
    {
      this._parent._log('debug','readlater.touch','Missing has_localdb, using page cache only',post_id);
    }
  },
  add:async function(post_id,title,images,excerpt,metadata=[],type=false,service=false,source=false)
  {
    try
    {
      if(post_id && !(isNaN(post_id)))
      {
        let current_data = await this.get(false,true,false);
        if(typeof current_data === 'object' && 'data' in current_data)
        {
          this._parent._log('debug','readlater.add','Adding to',current_data);

          let current_date = new Date();
          current_date=new Date(current_date.getFullYear(),current_date.getMonth(),current_date.getDate()).getTime()/1000;

          current_data.data[post_id]=JSON.parse(JSON.stringify({
            "id":post_id,
            "title": title,
            "images": images,
            "excerpt": excerpt,
            "metadata": metadata,
            "type": type,
            "service": service,
            "source": source,
            "lastupdate": current_date
          }));


          this._parent._log('debug','readlater.add','Added',current_data);
          window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
            'event_type':'readlater',
            'data': {
              'action':'add',
              'id':post_id
            }
          }}));

          if('name' in current_data && current_data.name=='readlater')
          {
            return await this._parent.post('data',current_data);
          }
          else
          {
            return false;
          }

        }
        else
        {
          throw "current_data is not an object or is missing data";
        }
      }
      else
      {
        throw "post_id is not a number";
      }

    }
    catch(ex)
    {
        this._parent._log('error','readlater.add',ex);
        return false;
    }
  }
}
